import { createFileRoute } from "@tanstack/react-router";
import { seoHead } from "@/config/seoHead";
import { permanentRedirect } from "@/lib/legacyRedirects";
import { notFoundUnlessRedirected } from "@/lib/slugGuards";
// Bara sökvägsdatan – att importera OffertKategori-sidan här drog in hela sidan
// (kalkylatorer, produktkatalog m.m.) i huvudpaketet.
import { categoryPath, isOfferCategory } from "@/data/offerCategoryPaths";

/**
 * Gamla /jamfor-offerter/<kategori> – permanent omdirigering (301) till
 * kategorins sida redan i serversvaret. Okända kategorier ger 404.
 */
export const Route = createFileRoute("/jamfor-offerter/$slug")({
  head: () => seoHead("/jamfor-offerter/$slug"),
  beforeLoad: async ({ params }) => {
    if (isOfferCategory(params.slug)) permanentRedirect(categoryPath(params.slug));
    await notFoundUnlessRedirected(`/jamfor-offerter/${params.slug}`);
  },
});
